export default function prepareErrorForVuexStore(error, fallbackMessage) {
    if (!error) return error;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return (error && error.message) || fallbackMessage || 'Unknown error';
    return error;
}
